import { Component } from '@angular/core';

@Component({
    selector: 'app-fisioterapista',
    imports: [],
    templateUrl: './fisioterapista.component.html',
    styleUrl: './fisioterapista.component.css'
})
export class FisioterapistaComponent {

}
